import { render, staticRenderFns } from "./SocietyMatchesMatchContainer.vue?vue&type=template&id=9af1bf1a&scoped=true"
import script from "./SocietyMatchesMatchContainer.vue?vue&type=script&lang=js"
export * from "./SocietyMatchesMatchContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af1bf1a",
  null
  
)

export default component.exports